
export const Favourite=()=>{
    return(
        <>
        Favourite
        </>
    )
}